/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { IFrontOwnProps, IFrontStateProps, IFrontDispatchProps, Front } from "../../components/front/Front/Front";
import { FrontThunkDispatch, getFront } from "source/models/store/front";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IFrontOwnProps): IFrontStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            frontPage: null,
            event: null
        };
    }
    const front = applicationState.front;
    return {
        appState: applicationState.session,
        dataId: front.page.dataId,
        frontPage: front.page.frontPage,
        event: front.event
    };
}

export function mapDispatchToProps(dispatch: FrontThunkDispatch): IFrontDispatchProps {
    return {
        loadFront: () => dispatch(getFront()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<IFrontStateProps, IFrontDispatchProps, IFrontOwnProps>(mapStateToProps, mapDispatchToProps)(Front);